import { map } from 'rxjs';

import { HttpResponse, type HttpEvent, type HttpInterceptorFn } from '@angular/common/http';

import { type ApiEnvelope, unwrapApiEnvelope } from '@entities/http';

import { BYPASS_UNWRAP } from '../tokens/bypass-unwprap';

export const unwrapApiEnvelopeInterceptor: HttpInterceptorFn = (request, next) => {
  const isJson = (request.responseType ?? 'json') === 'json';
  const shouldBypass = request.context.get(BYPASS_UNWRAP) || !isJson;

  const isI18nRequest = request.url.includes('i18n');
  if (isI18nRequest) {
    return next(request);
  }

  return next(request).pipe(
    map((event: HttpEvent<unknown>) => {
      if (shouldBypass || !(event instanceof HttpResponse)) {
        return event;
      }

      const body = event.body as ApiEnvelope<unknown>;
      const unwrappedBody = unwrapApiEnvelope(body);

      return event.clone({ body: unwrappedBody });
    }),
  );
};
